<template>
  <form>
    <naj-box
      :title="local.bankruptcy.requestDetails.title"
      no-gutters
    >
      <div class="row m-0">
        <div class="col-2 tabs-box">
          <v-tabs
            v-model="tab"
            vertical
            hide-slider
          >
            <v-tab
              v-for="navTab in tabs"
              :key="navTab.href"
              :disabled="navTab.disabled"
              :href="navTab.href"
              class="tab-button"
              active-class="tab-active"
              v-text="navTab.title"
            ></v-tab>
          </v-tabs>
        </div>
        <div class="col-10 p-2">
          <v-tabs-items v-model="tab">
            <v-tab-item
              v-if="tab == 'tab-1'"
              value="tab-1"
            >
              <partners-tab 
                :request-object-key="requestObjectKey"
                :request-owner-type-id="mainRequest.requestOwnerTypeId">
                <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.partnersConfirmation"></audit-confirmation-flag-checkbox>
              </partners-tab>
            </v-tab-item>
            <v-tab-item
              v-if="tab == 'tab-2'"
              value="tab-2"
            >
              <branches-tab :request-object-key="requestObjectKey">
                <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.branchesConfirmation"></audit-confirmation-flag-checkbox>
              </branches-tab>
            </v-tab-item>
            <v-tab-item
              v-if="tab == 'tab-3'"
              value="tab-3"
            >
              <bankrupt-debts-tab 
                :request-object-key="requestObjectKey"
                :request-owner-type-id="mainRequest.requestOwnerTypeId">
                <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.bankruptDebtsConfirmation"></audit-confirmation-flag-checkbox>
              </bankrupt-debts-tab>
            </v-tab-item>
            <v-tab-item
              v-if="tab == 'tab-4'"
              value="tab-4"
            >
              <debtor-assets-tab :request-object-key="requestObjectKey">
                <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.debtorAssetsConfirmation"></audit-confirmation-flag-checkbox>
              </debtor-assets-tab>
            </v-tab-item>
            <v-tab-item
              v-if="tab == 'tab-5'"
              value="tab-5"
            >
              <bankrupt-due-rights-tab 
                :request-object-key="requestObjectKey"
                :request-owner-type-id="mainRequest.requestOwnerTypeId">
                <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.bankruptDueRightsConfirmation"></audit-confirmation-flag-checkbox>
              </bankrupt-due-rights-tab>
            </v-tab-item>
            <v-tab-item
              v-if="tab == 'tab-6'"
              value="tab-6"
            >
              <debtor-employees-tab :request-object-key="requestObjectKey">
                <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.debtorEmployeesConfirmation"></audit-confirmation-flag-checkbox>
              </debtor-employees-tab>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </naj-box>
    <v-row>
      <v-col
        cols="12"
        class="text-left"
      >
        <naj-button
          outlined
          @click="updateCurrentStep(stepsEnum.requestApplicantData)"
        >
          {{ local.common.back }}
        </naj-button>
        <naj-button @click="updateCurrentStep(stepsEnum.requestAttachments)">
          {{ local.common.next }}
        </naj-button>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapState: mapState } = createNamespacedHelpers('BankruptcyModule');
import PartnersTab from './partners-tab/index';
import BranchesTab from './branches-tab/index';
import BankruptDebtsTab from './bankrupt-debts-tab/index';
import DebtorAssetsTab from './debtor-assets-tab/index';
import BankruptDueRightsTab from './bankrupt-due-rights-tab/index';
import DebtorEmployeesTab from './debtor-employees-tab/index';
import { stepsEnum, mainRequestAuditFlag } from '@/modules/bankruptcy/helpers/enum';
import AuditConfirmationFlagCheckbox from '@/modules/bankruptcy/components/request/audit-confirmation-flag-checkbox';

export default {
  components: {
    PartnersTab,
    BranchesTab,
    BankruptDebtsTab,
    DebtorAssetsTab,
    BankruptDueRightsTab,
    DebtorEmployeesTab,
    AuditConfirmationFlagCheckbox,
  },
  data() {
    return {
      stepsEnum,
      tab: null,
      mainRequestAuditFlag,
    };
  },
  computed: {
    ...mapState({ mainRequest: state => state.mainRequest }),
    ...mapGetters([
      'requestObjectKey',
      'isViewMode',
      'isNewMode',
      'isEditMode',
      'isNotCompleted',
    ]),
    tabs() {
      return [
        {
          href: '#tab-1',
          title: this.local.bankruptcy.requestDetails.partners.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-2',
          title: this.local.bankruptcy.requestDetails.branches.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-3',
          title: this.local.bankruptcy.requestDetails.bankruptDebts.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-4',
          title: this.local.bankruptcy.requestDetails.debtorAssets.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-5',
          title: this.local.bankruptcy.requestDetails.bankruptDueRights.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-6',
          title: this.local.bankruptcy.requestDetails.debtorEmployees.tabTitle,
          disabled: false,
        },
      ];
    },
  },
  methods: {
    submit() {
    },
    updateCurrentStep(stepId) {
      this.$emit('onUpdateCurrentStep', stepId);
    },
  },
};
</script>

<style lang="scss" scoped>
    .tabs-box {
        padding: 0;
        border-left: 2px solid #dbdbdb;

        .tab-button {
            margin-left: 4px;
            font: normal normal normal 16px/24px Almarai;
            justify-content: right;

            &.tab-active {
                border-left: 4px solid var(--app-primary-color);
            }
        }
    }
</style>
